import { createAction, props } from '@ngrx/store';
import { Template, TemplatePaginationState } from '../../models/template.model';

// Load Templates
export const loadTemplates = createAction(
  '[Templates] Load Templates',
  props<{ pageNumber: number; pageSize: number; mode?: string; search?: string }>()
);
export const loadTemplatesSuccess = createAction(
  '[Templates] Load Templates Success',
  props<{ templates: Template[]; pagination: TemplatePaginationState }>()
);
export const loadTemplatesFailure = createAction(
  '[Templates] Load Templates Failure',
  props<{ error: string }>()
);

// Load Template
export const loadTemplate = createAction('[Templates] Load Template', props<{ id: string }>());
export const loadTemplateSuccess = createAction(
  '[Templates] Load Template Success',
  props<{ template: Template }>()
);
export const loadTemplateFailure = createAction(
  '[Templates] Load Template Failure',
  props<{ error: string }>()
);

// Create Template
export const createTemplate = createAction(
  '[Templates] Create Template',
  props<{ template: Template; id: string }>()
);
export const createTemplateSuccess = createAction(
  '[Templates] Create Template Success',
  props<{ template: Template }>()
);
export const createTemplateFailure = createAction(
  '[Templates] Create Template Failure',
  props<{ error: string }>()
);

// Update Template
export const updateTemplate = createAction(
  '[Templates] Update Template',
  props<{ id: string; template: Template }>()
);
export const updateTemplateSuccess = createAction(
  '[Templates] Update Template Success',
  props<{ template: Template }>()
);
export const updateTemplateFailure = createAction(
  '[Templates] Update Template Failure',
  props<{ error: string }>()
);

// Delete Template
export const deleteTemplate = createAction('[Templates] Delete Template', props<{ id: string }>());
export const deleteTemplateSuccess = createAction(
  '[Templates] Delete Template Success',
  props<{ id: string }>()
);
export const deleteTemplateFailure = createAction(
  '[Templates] Delete Template Failure',
  props<{ error: string }>()
);
